import { ApiErrorCode as o } from "@hprofits/api/common/errors";
import { ApiError as E } from "./errors.js";
const e = (r) => r instanceof E ? r : void 0, i = (r) => (t) => e(t)?.errorCode === r, n = i(o.ENTITY_IN_USE), p = i(o.ENTITY_ALREADY_EXISTS), c = i(o.AUTH_REJECTED);
export {
  e as extractApiError,
  p as isApiErrorAlreadyExists,
  c as isApiErrorAuthRejected,
  n as isApiErrorInUse
};
//# sourceMappingURL=utils.js.map
